// extracted by mini-css-extract-plugin
module.exports = {"main":"PremiumTraitAccessDeniedBar_main__G7wp6","text":"PremiumTraitAccessDeniedBar_text__x_5iH","btnDiv":"PremiumTraitAccessDeniedBar_btnDiv__2qS4q"};